/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetUniverseMoonsMoonIdPosition } from './GetUniverseMoonsMoonIdPosition';
import {
    GetUniverseMoonsMoonIdPositionFromJSON,
    GetUniverseMoonsMoonIdPositionFromJSONTyped,
    GetUniverseMoonsMoonIdPositionToJSON,
    GetUniverseMoonsMoonIdPositionToJSONTyped,
} from './GetUniverseMoonsMoonIdPosition';

/**
 * 200 ok object
 * @export
 * @interface GetUniverseMoonsMoonIdOk
 */
export interface GetUniverseMoonsMoonIdOk {
    /**
     * moon_id integer
     * @type {number}
     * @memberof GetUniverseMoonsMoonIdOk
     */
    moonId: number;
    /**
     * name string
     * @type {string}
     * @memberof GetUniverseMoonsMoonIdOk
     */
    name: string;
    /**
     * 
     * @type {GetUniverseMoonsMoonIdPosition}
     * @memberof GetUniverseMoonsMoonIdOk
     */
    position: GetUniverseMoonsMoonIdPosition;
    /**
     * The solar system this moon is in
     * @type {number}
     * @memberof GetUniverseMoonsMoonIdOk
     */
    systemId: number;
}

/**
 * Check if a given object implements the GetUniverseMoonsMoonIdOk interface.
 */
export function instanceOfGetUniverseMoonsMoonIdOk(value: object): value is GetUniverseMoonsMoonIdOk {
    if (!('moonId' in value) || value['moonId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('position' in value) || value['position'] === undefined) return false;
    if (!('systemId' in value) || value['systemId'] === undefined) return false;
    return true;
}

export function GetUniverseMoonsMoonIdOkFromJSON(json: any): GetUniverseMoonsMoonIdOk {
    return GetUniverseMoonsMoonIdOkFromJSONTyped(json, false);
}

export function GetUniverseMoonsMoonIdOkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUniverseMoonsMoonIdOk {
    if (json == null) {
        return json;
    }
    return {
        
        'moonId': json['moon_id'],
        'name': json['name'],
        'position': GetUniverseMoonsMoonIdPositionFromJSON(json['position']),
        'systemId': json['system_id'],
    };
}

export function GetUniverseMoonsMoonIdOkToJSON(json: any): GetUniverseMoonsMoonIdOk {
    return GetUniverseMoonsMoonIdOkToJSONTyped(json, false);
}

export function GetUniverseMoonsMoonIdOkToJSONTyped(value?: GetUniverseMoonsMoonIdOk | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'moon_id': value['moonId'],
        'name': value['name'],
        'position': GetUniverseMoonsMoonIdPositionToJSON(value['position']),
        'system_id': value['systemId'],
    };
}

